import { MediaLibraryState } from './types';

export const selectMediaLibrary = (state: {
  mediaLibrary: MediaLibraryState;
}) => state.mediaLibrary.mediaLibrary;

export const selectMediaLibraryFetchState = (state: any) => state.mediaLibrary.mediaLibraryFetchState;